module.exports = __webpack_public_path__ + "static/media/userp.f854676d.png";